import {
    FETCH_FTP_FETCHING,
    FETCH_FTP_FAIL,
    FETCH_FTP_SUCCESS,
    FETCH_POWER_TO_WEIGHT_FETCHING,
    FETCH_POWER_TO_WEIGHT_FAIL,
    FETCH_POWER_TO_WEIGHT_SUCCESS,
    TOGGLE_SPORT,
    SWITCH_POWER_TO_WEIGHT_FILTER
} from '../../actions/ActionTypes';
import { CYCLING } from 'FTP/utils/ftpUtils';

const INITIAL_STATE = {
    ftpData: [],
    isFTPFetching: false,
    powerToWeightData: [],
    isPowerToWeightFetching: false,
    powerToWeightFilter: 'ftp',
    selectedSports: CYCLING
};

const fetchFTPFetching = (state) => ({
    ...state,
    isFTPFetching: true
});

const fetchFTPFail = (state) => ({
    ...state,
    isFTPFetching: false
});

const fetchFTPSuccess = (state, { data }) => ({
    ...state,
    ftpData: Array.isArray(data) ? data : [],
    isFTPFetching: false
});

export const isFTPFetching = (state) => {
    return state && state.ftpRange && state.ftpRange.isFTPFetching;
};

const fetchPowerToWeightFetching = (state) => ({
    ...state,
    isPowerToWeightFetching: true
});

const fetchPowerToWeightFail = (state) => ({
    ...state,
    isPowerToWeightFetching: false
});

const fetchPowerToWeightSuccess = (state, { data }) => ({
    ...state,
    powerToWeightData: Array.isArray(data) ? data : [],
    isPowerToWeightFetching: false
});

export const isPowerToWeightFetching = (state) => {
    return state && state.ftpRange && state.ftpRange.isPowerToWeightFetching;
};

const toggleSport = (state, { payload: { sportFilter } }) => ({
    ...state,
    selectedSports: sportFilter
});

const switchFilter = (state, { payload: { filter } }) => ({
    ...state,
    powerToWeightFilter: filter
});

const handlers = {
    [FETCH_FTP_FETCHING]: fetchFTPFetching,
    [FETCH_POWER_TO_WEIGHT_FETCHING]: fetchPowerToWeightFetching,
    [FETCH_FTP_FAIL]: fetchFTPFail,
    [FETCH_POWER_TO_WEIGHT_FAIL]: fetchPowerToWeightFail,
    [FETCH_FTP_SUCCESS]: fetchFTPSuccess,
    [FETCH_POWER_TO_WEIGHT_SUCCESS]: fetchPowerToWeightSuccess,
    [TOGGLE_SPORT]: toggleSport,
    [SWITCH_POWER_TO_WEIGHT_FILTER]: switchFilter
};

export default function ftpRange(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
